var _rect, _path, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChangeAvatar = function SvgChangeAvatar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 19,
    rx: 9.5,
    fill: "#4F4F4F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3538 5.64645L14.3538 7.64645C14.5491 7.84171 14.5491 8.15829 14.3538 8.35355L8.85383 13.8536C8.78403 13.9234 8.69513 13.9709 8.59834 13.9903L6.09834 14.4903C5.74848 14.5603 5.44002 14.2518 5.50999 13.9019L6.00999 11.4019C6.02935 11.3051 6.07692 11.2162 6.14672 11.1464L11.6467 5.64645C11.842 5.45118 12.1586 5.45118 12.3538 5.64645ZM10.75 7.957L6.96088 11.7465L6.63766 13.3626L8.25377 13.0394L12.043 9.25L10.75 7.957ZM12.0003 6.70711L11.4575 7.25L12.75 8.5425L13.2932 8L12.0003 6.70711Z",
    fill: "#BDBDBD"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 19,
    rx: 9.5,
    stroke: "white"
  })));
};
export { SvgChangeAvatar as ReactComponent };
export default __webpack_public_path__ + "assets/18b5ce1c.svg";